import Cookies from "js-cookie";
import { getAllProducts, getAuthProducts } from "@/api/apps";

const state = {
  theme: Cookies.get("theme") || "#3366FF",
  haveLogin: Cookies.get("haveLogin"),

  authProducts: [],
  productsData: [],
  solutionsData: []
};

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value;
      Cookies.set(key, value);
    }
  },

  SET_AUTH_PRODUCTS: (state, data) => {
    state.authProducts = data || [];
  },
  SET_ALL_PRODUCTS: (state, data) => {
    state.productsData = data.productsData;
    state.solutionsData = data.solutionsData;
  }
};

const actions = {
  changeSetting({ commit }, data) {
    commit("CHANGE_SETTING", data);
  },

  async getAuthProducts({ commit }) {
    const { data: authProductsData } = await getAuthProducts();
    authProductsData.data.forEach(item => {
      if (item.groupName === "智库") {
        const authProducts = item.children || [];
        commit("SET_AUTH_PRODUCTS", authProducts);
      }
    });
  },

  async getAllProducts({ commit }) {
    const { data: allProductsData } = await getAllProducts();
    let productsData = [];
    let solutionsData = [];

    if (allProductsData.data.length) {
      allProductsData.data.forEach(item => {
        if (item.groupName === "智库") {
          productsData = item.children || [];
        }
        if (item.groupName === "智策") {
          solutionsData = item.children || [];
        }
      });
    }

    commit("SET_ALL_PRODUCTS", { productsData, solutionsData });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
